export interface ICity {
  ID: number;
  Name?: string;
  CityName?: string;
  PrefectureId?: string;
  NomosID?: number;
  Nomos?: string;
}

export class City implements ICity {
  ID: number;
  Name?: string;
  CityName?: string;
  PrefectureId?: string;
  NomosID?: number;
  Nomos?: string;

  constructor();
  constructor(obj: ICity);
  constructor(obj?: ICity) {
    this.ID = obj?.ID ?? -1;
    this.Name = obj?.Name ?? '';
    this.NomosID = obj?.NomosID ?? -1;
    this.Nomos = obj?.Nomos ?? '';
    this.CityName = obj?.Name ?? '';
    this.PrefectureId = obj?.PrefectureId ?? '';
  }
}
